import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './week-day-time.reducer';

export const WeekDayTimeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const weekDayTimeEntity = useAppSelector(state => state.weekDayTime.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="weekDayTimeDetailsHeading">
          <Translate contentKey="activitiesApp.weekDayTime.detail.title">WeekDayTime</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{weekDayTimeEntity.id}</dd>
          <dt>
            <span id="weekDay">
              <Translate contentKey="activitiesApp.weekDayTime.weekDay">Week Day</Translate>
            </span>
          </dt>
          <dd>{weekDayTimeEntity.weekDay}</dd>
          <dt>
            <span id="fromTime24H">
              <Translate contentKey="activitiesApp.weekDayTime.fromTime24H">From Time 24 H</Translate>
            </span>
          </dt>
          <dd>{weekDayTimeEntity.fromTime24H}</dd>
          <dt>
            <span id="toTime24H">
              <Translate contentKey="activitiesApp.weekDayTime.toTime24H">To Time 24 H</Translate>
            </span>
          </dt>
          <dd>{weekDayTimeEntity.toTime24H}</dd>
          <dt>
            <span id="duration">
              <Translate contentKey="activitiesApp.weekDayTime.duration">Duration</Translate>
            </span>
          </dt>
          <dd>{weekDayTimeEntity.duration}</dd>
          <dt>
            <span id="adultCount">
              <Translate contentKey="activitiesApp.weekDayTime.adultCount">Adult Count</Translate>
            </span>
          </dt>
          <dd>{weekDayTimeEntity.adultCount}</dd>
          <dt>
            <span id="childCount">
              <Translate contentKey="activitiesApp.weekDayTime.childCount">Child Count</Translate>
            </span>
          </dt>
          <dd>{weekDayTimeEntity.childCount}</dd>
          <dt>
            <span id="infantCount">
              <Translate contentKey="activitiesApp.weekDayTime.infantCount">Infant Count</Translate>
            </span>
          </dt>
          <dd>{weekDayTimeEntity.infantCount}</dd>
          <dt>
            <Translate contentKey="activitiesApp.weekDayTime.activitySchedule">Activity Schedule</Translate>
          </dt>
          <dd>{weekDayTimeEntity.activitySchedule ? weekDayTimeEntity.activitySchedule.scheduleName : ''}</dd>
        </dl>
        <Button tag={Link} to="/week-day-time" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/week-day-time/${weekDayTimeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default WeekDayTimeDetail;
